"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGetAboutContent = exports.prefetchGetAboutContent = void 0;
var _filter2 = _interopRequireDefault(require("lodash/filter"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _map2 = _interopRequireDefault(require("lodash/map"));
var _getAboutContent = _interopRequireDefault(require("@lumirental/lumi-web-sdk/dist/clients/cms/getAboutContent"));
var _aboutFactory = _interopRequireDefault(require("@lumirental/lumi-web-sdk/dist/factories/cms/aboutFactory"));
var _Language = require("@lumirental/lumi-web-shared/lib/contexts/Language.context");
var _config = require("./config");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Query Config
 * @param {Object} options
 * @property {UseQueryOptions} options.config
 * @returns Object
 */

var queryConfig = function queryConfig() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    config = _ref.config;
  return _objectSpread({
    queryKey: ['about'],
    queryFn: function queryFn() {
      return (0, _getAboutContent["default"])(process.env.APP_ENV);
    },
    enabled: false
  }, config);
};

/**
 * Query fetch/sync
 */

var useFetchAboutContent = function useFetchAboutContent(options) {
  return (0, _config.useFetch)(queryConfig(options));
};

/**
 * Query fetch/sync and format data
 */
var useGetAboutContent = exports.useGetAboutContent = function useGetAboutContent(options) {
  var queryRes = useFetchAboutContent(options);
  var _useLanguageContext = (0, _Language.useLanguageContext)(),
    language = _useLanguageContext.language;
  var localizedContent = (0, _filter2["default"])(queryRes === null || queryRes === void 0 ? void 0 : queryRes.data, function (item) {
    return (0, _get2["default"])(item, 'locale') === language;
  });
  var factoryContent = (0, _map2["default"])(localizedContent, function (about) {
    return (0, _aboutFactory["default"])(about);
  });
  var aboutContent = (0, _get2["default"])(factoryContent, '0', {});
  return _objectSpread(_objectSpread({}, queryRes), {}, {
    aboutContent: aboutContent
  });
};
var prefetchGetAboutContent = exports.prefetchGetAboutContent = function prefetchGetAboutContent(options) {
  return function (queryClient) {
    return queryClient.fetchQuery(queryConfig(options));
  };
};